export default __webpack_public_path__ + "static/media/Smile of Tartaros.e636600a.jpg";